<template>
  <div
    class="tab-nav-item"
    :class="itemClass"
    @click="onTabClick(navItem, $event)"
    @mousedown="onTabMouseDown(navItem, $event)"
  >
    <div class="subitem">
      <span>{{ navItem.label || navItem.name }}</span>
      <el-icon v-if="navItem.closeable !== false" class="icon-close" @click="onTabRemove(navItem, $event)">
        <Close />
      </el-icon>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from '@zto/zpage'
import { Close } from '@element-plus/icons'

import type { GenericFunction } from '@zto/zpage'

const props = defineProps<{
  navItem: Record<string, any>
  currentKey?: string
  onTabRemove: GenericFunction
  onTabClick: GenericFunction
  onTabMouseDown: GenericFunction
}>()

const itemClass = computed(() => {
  const { currentKey, navItem } = props
  const active = navItem.key === currentKey

  return {
    active,
    closeable: navItem.meta?.closeable
  }
})
</script>

<style lang="scss" scoped>
.tab-nav-item {
  position: relative;
  cursor: pointer;
  height: 36px;
  padding: 6px 8px 6px;
  line-height: 20px;
  color: #606266;
  font-size: 14px;
  border: none;
  display: inline-block;
  box-sizing: border-box;

  .icon-close {
    font-size: 16px;
    color:#909399 !important;
    cursor: pointer;
    margin-left: 8px;
    position: relative;
    top: 3px;
  }

  .subitem {
    padding: 0 16px;
    border-left: 1px solid var(--border-color);
  }

  &:first-child .subitem {
    border-left: 1px solid transparent;
  }

  &:hover {
    background: rgba(238, 240, 246, 1);
    border-radius: 4px 4px 0px 0px;
    opacity: 0.3;

    .subitem {
      border-left: 1px solid transparent;
    }

    & + .tab-nav-item .subitem {
      border-left: 1px solid transparent;
    }
  }

  &.active {
    color: #031646;
    font-size: 14px;
    font-weight: 500;
    background: linear-gradient(180deg, #b6c9ff, #d6e8fb);
    border-radius: 4px 4px 0px 0px;
    opacity: 1;

    .subitem {
      border-left: 1px solid transparent;
    }

    & + .tab-nav-item .subitem {
      border-left: 1px solid transparent;
    }

    .icon-close {
      color: var(--primary);
    }

    &:before,
    &:after {
      content: "";
    position: absolute;
    width: 12px;
    height: 20px;
    -webkit-box-shadow: 0 10px 0 var(--pl-tab-bottom-color,#d6e8fb);
    box-shadow: 0 10px 0 var(--pl-tab-bottom-color,#d6e8fb)
    }

    &:before {
      
      left: -12px;
    bottom: 0;
    border-bottom-right-radius: 20px;
    }

    &:after {
      bottom: 0;
    right: -12px;
    border-bottom-left-radius: 20px;
    }
  }
}
</style>
